"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _getProgramLayers = require("@studio/program/utils/getProgramLayers");
var _setProgramRealtime = _interopRequireDefault(require("./setProgramRealtime"));
var _sendToDatadogWithIds = require("../../utils/sendToDatadogWithIds");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Builds a new scene replacing previous source values for a supplied source.
 *
 * This allows us to keep a scene unchanged except for a source that's changed, for example an audio source that has
 * changed from `muted: false` to `muted: true`.
 */
var _default = exports["default"] = function _default(changedSource) {
  var realtime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var setProgramCb = arguments.length > 2 ? arguments[2] : undefined;
  return function (dispatch, getState) {
    var _getState = getState(),
      program = _getState.program;
    var nextScene = _objectSpread({}, program);
    var currentLayers = (0, _getProgramLayers.getProgramLayers)(program);
    nextScene.layers = currentLayers.map(function (layerSource) {
      var source = layerSource.source;
      if ((source === null || source === void 0 ? void 0 : source._id) === changedSource._id) {
        return _objectSpread(_objectSpread({}, layerSource), {}, {
          source: changedSource
        });
      }
      return layerSource;
    });
    if (realtime) {
      return dispatch((0, _setProgramRealtime["default"])(nextScene));
    }
    (0, _sendToDatadogWithIds.logProgramChange)(getState, 'setSourceChangesToProgram action');
    setProgramCb && setProgramCb(nextScene);
  };
};